import { useEffect, useState } from "react";
import "./AdminTeam.css";

function AdminTeam() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    fetch("/api/admin/team", { credentials: "include" })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Admin team API unavailable");
        }

        return response.json();
      })
      .then((data) => {
        if (data.ok && Array.isArray(data.members)) {
          setMembers(data.members);
        }
      })
      .catch(() => {
        // Keep the page available while the API is unavailable.
      });
  }, []);

  const roles = [
    "Lead Admin",
    "Admin",
    "Moderator",
    "Assistant",
    "Technician",
  ];

  return (
    <section className="bubly-admin-team">
      <div className="bubly-admin-panel">
        <div className="bubly-admin-panel-header">
          <div>
            <span>SYSTEM</span>
            <h2>Team & Roles</h2>
          </div>
        </div>

        <div>
          {roles.map((role) => {
            const roleMembers = members.filter(
              (member) => member.role?.toLowerCase() === role.toLowerCase()
            );

            return (
              <div
                className={role === "Lead Admin" ? "team-primary" : "team-role"}
                key={role}
              >
                <strong>{role}</strong>

                {roleMembers.length === 0 ? (
                  <div className="team-empty">
                    <span>No members assigned</span>
                  </div>
                ) : (
                  roleMembers.map((member) => (
                    <div className="team-member" key={member.role_assignment_id}>
                      <div>
                        <span className="team-member-name">
                          {member.name || "Unnamed account"}
                        </span>

                        <span className="team-member-email">
                          {member.email}
                        </span>
                      </div>

                      <span className="team-member-role">
                        {member.role}
                      </span>
                    </div>
                  ))
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default AdminTeam;
